/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import type { TaskList, Cards } from '../../../../common/types.tsx';
import { JSM_TASK_LIST, JSM_TASK_VARIANTS, UserRole, Experiments } from './constants.tsx';

export const JSM: {
	readonly taskList: TaskList;
	readonly taskVariants: Cards;
	readonly userRole: {
		readonly projectAdmin: 'projectAdmin';
		readonly jiraAdmin: 'jiraAdmin';
		readonly siteAdmin: 'siteAdmin';
	};
	readonly experiments: {
		readonly projectTheming: 'projectTheming';
	};
} = {
	taskList: JSM_TASK_LIST,
	taskVariants: JSM_TASK_VARIANTS,
	userRole: UserRole,
	experiments: Experiments,
} as const;
